module.exports = __webpack_public_path__ + "static/media/cotrip.8e8bcba7.png";